import Icon from '../components/Icon.vue'

Icon.register({
  'poll-h': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 432c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352zM112 192h128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zM112 288h224c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zM112 384h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/poll-h.js
// module id = 1651
// module chunks = 0